import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { RapportASignerState } from './state';

export const getters: GetterTree<RapportASignerState, RootState> = {
    getRapportASignerItems(state) {
        return state.rapports;
    },
    getRapportInterventionFilterSite(state): Array<number> {
        return state.filterSite;
    },
    getRapportInterventionFilterInterventionId(state): string {
        return state.filterInterventionId;
    },
    getRapportInterventionFilterPredictedDateFrom(state): string {
        return state.filterPredictedDateFrom;
    },
    getRapportInterventionFilterPredictedDateTo(state): string {
        return state.filterPredictedDateTo;
    },
    getRapportASignerIsLoading(state) {
        return state.isLoading;
    },
    getRapportASignerPage(state) {
        return state.page;
    },
    getRapportASignerNbOfPages(state) {
        return state.nbOfPages;
    },
    getRapportsASignerScroll(state) {
        return state.scroll;
    },
    getRapportASignerSort(state) {
        return state.sort;
    },
    getRapportsASignerCount(state) {
        return state.count;
    },
    getRapportASignerTableHeader(state) {
        return state.tableHeader;
    },
    getXlsIsLoading(state) {
        return state.isExportXlsLoading;
    },
};
